import tippy from "tippy.js";
import 'tippy.js/themes/light.css';

export class Tooltip extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.tooltip = tippy(this, {
            content: this.dataset.content || "",
            allowHTML: true,
            animation: "shift-away",
            placement: this.dataset.placement || "bottom",
            theme: "light",
            interactive: true
        });
    }

    disconnectedCallback() {
        if (this.tooltip) {
            this.tooltip.destroy(); // Vérifier si l'info-bulle existe avant de la détruire
        }
    }
}
